// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".d64b9b{position:relative;transition:height 200ms cubic-bezier(1, 0, 0, 1)}.d64b9b.growing{transition:height 200ms cubic-bezier(0.24, 0.88, 0.27, 1.12)}.d64b9b.dc5e00>:first-child{position:absolute;top:0;right:0;bottom:auto;left:0}.d64b9b:not(.dc5e00){transition:none}.fbb716{overflow:hidden}", ""]);
// Exports
exports.locals = {
	"container": "d64b9b",
	"mounted": "dc5e00",
	"overflow-hidden": "fbb716",
	"overflowHidden": "fbb716"
};
module.exports = exports;
